import { useTranslation } from "./runtime";

export default function LanguagePicker() {
  const { language, setLanguage, t } = useTranslation();
  return (
    <div className="translation-language-control">
      <svg className="translation-language-globe" width="18" height="18"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7"
        strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18M12 3c3 3 4 6 4 9s-1 6-4 9c-3-3-4-6-4-9s1-6 4-9Z" />
      </svg>
      <select className="translation-language-picker" value={language}
        aria-label={t("lnk_language", "Language")}
        onChange={(event) => setLanguage(event.target.value)}>
        <option value="en">English</option>
        <option value="ar">العربية</option>
      </select>
      <svg className="translation-language-chevron" width="14" height="14"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
        strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="m6 9 6 6 6-6" />
      </svg>
    </div>
  );
}
